var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-xs-center"},[_vm._v("\n\t\t"+_vm._s(_vm.company.name)+"\n\t")]),_c('td',[_c('edit-btn',{staticClass:"mx-2 my-1",on:{"click":_vm.onEdit}}),_c('remove-btn',{staticClass:"mx-2 my-1"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }